import { render } from "./createItemForm.vue?vue&type=template&id=8763a440&scoped=true"
import script from "./createItemForm.vue?vue&type=script&lang=js"
export * from "./createItemForm.vue?vue&type=script&lang=js"

import "./createItemForm.vue?vue&type=style&index=0&id=8763a440&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8763a440"]])

export default __exports__